import { Navigate, useParams } from "react-router-dom";
import {useAuth} from "../../context/AuthContext.tsx";
import {UserType} from "../../api/ApiTypes.ts";


export const OrderDetailsRouter = () => {
    const { me, isInitializing } = useAuth();
    const { id, action } = useParams();

    if (isInitializing) return null;
    if (!me) return <Navigate to="/login" replace />;

    const suffix = action ? `${id}/${action}` : id;

    switch (me.userType) {
        case UserType.APPRAISER:
        case UserType.APPRAISER_ADMIN:
        case UserType.SECRET:
            return <Navigate to={`/appraiser/orderdetails/${suffix}`} replace />;

        case UserType.STAFF:
            return <Navigate to={`/staff/orderdetails/${suffix}`} replace />;

        default:
            return <Navigate to="/unauthorized" replace />;
    }
};